import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Icon, Modal, Table,
} from 'semantic-ui-react';
import { get, map } from 'lodash';
import moment from 'moment/moment';
import AuditSearch from '../views/ReturnInvoices/AuditSearch';
import client from '../apollo';

class AuditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auditRecords: [],
      startDate: null,
      endDate: null,
      size: 25,
      offset: 0,
      lastPage: false,
    };
  }

  componentDidMount() {
    this.fetchAuditRecords();
  }

  fetchAuditRecords = () => {
    const {
      queryVariables, fetchAuditRecordQuery, auditResponseAttribute,
    } = this.props;
    const {
      startDate, endDate, size, offset,
    } = this.state;
    client.query({
      query: fetchAuditRecordQuery,
      variables: {
        ...queryVariables,
        startDate,
        endDate,
        size,
        offset,
      },
      fetchPolicy: 'network-only',
    }).then(({ data }) => {
      const auditRecords = get(data, auditResponseAttribute);
      if (auditRecords.length === 0 && offset > 0) {
        this.setState({
          lastPage: true,
        });
        return;
      }
      if (auditRecords.length < size) {
        this.setState({
          auditRecords,
          lastPage: true,
        });
      } else {
        this.setState({
          auditRecords,
          lastPage: false,
        });
      }
    }).catch(() => {
      this.setState({
        auditRecords: [],
      });
    });
  };

  render() {
    const {
      renderAuditRow, renderChangesetRow, header, isAuditModalOpen, onCloseHandler,
    } = this.props;

    const {
      size, offset, lastPage, auditRecords, startDate, endDate,
    } = this.state;

    const currentPage = Math.floor(offset / size) + 1;
    const hasResults = auditRecords && auditRecords.length > 0;

    const start = hasResults ? offset + 1 : 0;
    const end = offset + (auditRecords?.length || 0);

    const onDateChangeHandler = (field, date) => {
      this.setState({
        [field]: moment(new Date(date), 'YYYY-MM-DD'),
      });
    };
    const clearDates = () => {
      this.setState({
        startDate: null, endDate: null, offset: 0, lastPage: false,
      }, () => {
        this.fetchAuditRecords();
      });
    };

    const handleSearch = () => {
      this.setState({ offset: 0, lastPage: false }, () => {
        this.fetchAuditRecords();
      });
    };

    const handlePageChange = (e, { activePage }) => {
      const newOffset = (activePage - 1) * size;
      this.setState({ offset: newOffset }, () => {
        this.fetchAuditRecords();
      });
    };

    return (
      <Modal
        open={isAuditModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>{header}</Modal.Header>
        <Modal.Content>
          <div>
            <AuditSearch
              onDateChangeHandler={onDateChangeHandler}
              clearDates={clearDates}
              startDate={startDate}
              endDate={endDate}
              onSearchHandler={handleSearch}
            />
            {map(auditRecords, auditRecord => (
              <Table celled padded size='big' style={{ margin: '0 0' }} key={auditRecord.id}>
                <Table.Body>
                  <Table.Row
                    style={{ backgroundColor: 'LightGray' }}
                  >
                    <Table.Cell width={12}> {renderAuditRow(auditRecord)}</Table.Cell>
                    <Table.Cell>{auditRecord.timeStamp}</Table.Cell>
                  </Table.Row>
                  { map(JSON.parse(auditRecord.changeset), (change, key) => renderChangesetRow(auditRecord, change, key))}
                </Table.Body>
              </Table>
            ))}
            {(hasResults || currentPage > 1) && (
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <span>
                  {hasResults ? (
                    <>
                      Showing <b>{start} - {end}</b>&nbsp;&nbsp;
                    </>
                  ) : (
                    <>No records on this page.&nbsp;&nbsp;</>
                  )}
                </span>
                <Button
                  icon
                  color='green'
                  inverted
                  disabled={currentPage === 1}
                  onClick={e => handlePageChange(e, { activePage: currentPage - 1 })}
                >
                  <Icon name='caret left' />
                </Button>
                <Button
                  icon
                  color='green'
                  inverted
                  disabled={lastPage}
                  onClick={e => handlePageChange(e, { activePage: currentPage + 1 })}
                >
                  <Icon name='caret right' />
                </Button>
              </div>
            )}
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

AuditModal.propTypes = {
  selectedRecord: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  isAuditModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,

  header: PropTypes.string,
  fetchAuditRecordQuery: PropTypes.shape({
    kind: PropTypes.string, // "Document"
    definitions: PropTypes.array, // array of query definitions
    loc: PropTypes.object, // source location
  }),
  queryVariables: PropTypes.object,
  auditResponseAttribute: PropTypes.string,
  renderAuditRow: PropTypes.func,
  renderChangesetRow: PropTypes.func,
};

AuditModal.defaultProps = {
  selectedRecord: {},
  isAuditModalOpen: false,
  onCloseHandler: () => {},

  header: null,
  fetchAuditRecordQuery: null,
  queryVariables: {},
  auditResponseAttribute: null,
  renderAuditRow: () => {},
  renderChangesetRow: () => {},
};

export default AuditModal;
